import { DEAL_LABELS } from "./common";

const TABS_LIST = {
  DEAL_TABLE: "DEAL_TABLE",
  DOCUMENT: "DOCUMENT",
  QUOTE_TABLE: "QUOTE_TABLE",
};

const TABS_WITH_DOCUMENT = [
  {
    name: "Document",
    alias: "DOCUMENT",
  },
];

const TABS_WITH_DEALTABLE = [
  {
    name: "Document",
    alias: "DOCUMENT",
  },
  {
    name: DEAL_LABELS["deal-table-label"],
    alias: "DEAL_TABLE",
  },
];

const TABS_WITH_QUOTETABLE = [
  {
    name: "Document",
    alias: "DOCUMENT",
  },
  {
    name: "Quote Table",
    alias: "QUOTE_TABLE",
  },
];

const QUOTE_STATUS_MAP = [
  { label: "DRAFT", value: "DRAFT" },
  { label: "PENDING APPROVAL", value: "PENDING_APPROVAL" },
  { label: "APPROVED", value: "APPROVED" },
  { label: "REJECTED", value: "REJECTED" },
];

export {
  QUOTE_STATUS_MAP,
  TABS_LIST,
  TABS_WITH_DOCUMENT,
  TABS_WITH_DEALTABLE,
  TABS_WITH_QUOTETABLE,
};



// WEBPACK FOOTER //
// ./src/constants/quotes.js